import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Toast,Modal} from 'antd-mobile';
import AuthCode from '../common/LoginAuthCode';
import ImageAuth from '../../components/Popup/ImageAuth';
import Http from '../../config/axiosUtils';
import {replaceNumber, validateAuthcode, validateTel} from '../../utils/validate';
import { removeStore, setStore } from '../../config/storage';
import './LoginCommon.scss';
import PartnerApply from '../../pages/Protocol/PartnerApply';

const params = new URLSearchParams(window.location.search);
const mobile = params.get('mobile') || '';
class LoginNew extends Component {
  
  state = {
    mobile: mobile === "null" ? '' : mobile,
    authCode: '',
    mobileClose: false, //手机号关闭按钮
    anthCodeClose: false, //验证码关闭按钮
    isSend: false, //是否可以获取验证码
    hasSend: false, //是否已经获取验证码
    isShowImageCode: false,
    regNum: /[^0-9]/g, //数字正则
    isRegister:false,
    showProtocol: false, //展示协议
    loginData:{},
  }

  //监听输入框变化和聚焦
  handelInput = (key, maxLength, event) => {
    const str = replaceNumber(event.target.value, maxLength);
    this.setState({
      [key]: str,
      mobileClose: key === 'mobile' && str,
      anthCodeClose: key === 'authCode' && str,
      isSend: false,
    })
  }

  //清空输入框
  deleteInput = (key) => {
    this.setState({
      [key]: '',
      mobileClose: !key === 'mobile',
      anthCodeClose: !key === 'authCode',
      isSend: false
    })
  }

  //判断手机号是否合法
  onHandlePhone = () => {
    if (!validateTel(this.state.mobile)) {
      Toast.info('请输入正确的手机号码！', 2);
      return;
    }
    this.sendAuthCode();
  }

  //发送验证码
  sendAuthCode = (obj) => {
    Toast.loading('发送中，请稍后...', 0.5, async () => {
      const path = '/spread/web/authCode/send';
      const postData = {
        mobile: this.state.mobile,
        type: this.props.type,
      }
      if (obj) {
        postData.requestId = obj.requestId;
        postData.validationCode = obj.validationCode;
      }
      const res = await Http.post(path, postData);
      if (res.code === 0) {
        Toast.hide();
        this.setState({
          isSend: true,
          isShowImageCode: false
        })
      } else if (res.code === 1001) {
        Toast.hide();
        this.setState({
          isShowImageCode: true
        })
      } else if (res.code === 1002) {
        Toast.fail(res.msg, 2);
        this.ImageAuth.clearImg();
      } else {
        Toast.fail(res.msg, 2);
      }
    });
  }

  //验证码发送成功回调
  onSuccessSend = () => {
    this.setState({
      hasSend: true,
      isSend: false
    });
  }

  next = () => {
    if (!validateTel(this.state.mobile)) {
      Toast.info('请输入正确的手机号码！', 2);
      return;
    }
    if (!this.state.hasSend) {
      Toast.info('请先获取验证码！', 2);
      return;
    }
    if (!validateAuthcode(this.state.authCode)) {
      Toast.info('请输入正确的验证码！', 2);
      return;
    }
    this.nextStep();
  }

  nextStep = () => {
    Toast.loading('loading...', 0.5, async () => {
      const path = this.props.type === 10 ? '/spread/web/authCode/simpleCheck' : '/spread/web/user/login';
      const postData = {
        mobile: this.state.mobile,
        authCode: this.state.authCode
      }
      if (this.props.type === 10) {
        postData.type = 10;
      }
      const res = await Http.post(path, postData);
      if (res.code === 0) {
        Toast.hide();
        if (res.data.agreementPop) {
          setStore('token', res.data.token);
          this.setState({
            loginData:res.data,
            isRegister:true,
          })
        } else  {
          this.props.nextFunc(this.props.type === 10 ? postData : res.data);
        }
      } else {
        this.setState({
          authCode: ''
        });
        Toast.fail(res.msg, 2);
      }
    });
  }

  registerProtocol = (isRegister) => {
    let element;
    element = (
        <Modal
            visible={isRegister}
            transparent
            maskClosable={false}
            title="注册协议更新"
            footer={[{ text: '不同意', onPress: () => {this.onClose()} },{ text: '同意', onPress: () => { this.sureAction()} }]}
            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          <div class="modalName">
            <p className="p_txt">尊敬的用户，我们更新了《创业合伙人申请》，特向您推送本提示。请仔细阅读并充分理解相关条款。</p>
            <p className="p_txt">您点击“同意”即表示您已阅读并同意更新后的《创业合伙人申请协议》，富金富将全力保障您的合法权益为您提供更优质的产品和服务。</p>
            <p className="p_pro">查看完整版 <span onClick={this.goProtocol}>《创业合伙人申请协议》</span></p>
          </div>
        </Modal>
    )
    return element;
  }

  onClose = () => {
    this.setState({
      isRegister:false,
    })
    removeStore("token");
  }

  goProtocol = () => {
    this.setState({
      showProtocol:true,
      isRegister:false,
    })
  }
  closeFunc = () => {
    this.setState({
      showProtocol:false,
      isRegister:true,
    })
  }

  agreeProtocol = async () => {
    const path = '/spread/web/user/agree/1'
    const res = await Http.get(path);
    if (res.code === 0) {
      const postData = {
        mobile: this.state.mobile,
        authCode: this.state.authCode
      }
      this.props.nextFunc(this.props.type === 10 ? postData : this.state.loginData);
    }
  }

  sureAction =() => {
    this.setState({
      isRegister:false,
    })
    this.agreeProtocol();
  }

  keyupEvent = (key, event) => {
    this.setState({
      [key]: event.target.value.replace(this.state.regNum, '')
    })
  }

  render () {
    let { mobile, authCode, mobileClose, anthCodeClose, isSend,isRegister} = this.state;
    let modal = this.registerProtocol(isRegister);
    return (
    <div className='loginNew'>
        <div className='loginNew-header'>
        </div>
        <div className='loginNew-mid'>
          <section className='loginNew-mobile-container'>
            <input type="tel"
                   placeholder="请输入手机号"
                   name="phone"
                   maxLength="11"
                   value={mobile}
                   onFocus={this.handelInput.bind(this, 'mobile', 11)}
                   onChange={this.handelInput.bind(this, 'mobile', 11)}
                   onKeyUp={this.keyupEvent.bind(this, 'mobile')} />
            {mobileClose && <i className='iconfont icon-delete' onClick={this.deleteInput.bind(this, 'mobile')}></i>}
          </section>
          <section className='loginNew-auth-container'>
            <input type="tel"
                   placeholder="请输入验证码"
                   name="authCode"
                   maxLength="6"
                   value={authCode}
                   onFocus={this.handelInput.bind(this, 'authCode', 6)}
                   onChange={this.handelInput.bind(this, 'authCode', 6)}
                   onKeyUp={this.keyupEvent.bind(this, 'authCode')} />
            {anthCodeClose && <i className='iconfont icon-delete' onClick={this.deleteInput.bind(this, 'authCode')}></i>}
            <AuthCode isSend={isSend} isHighColor={Boolean(mobile)} onHandlePhone={this.onHandlePhone} onSuccessSend={this.onSuccessSend}></AuthCode>
          </section>
          <div className={`loginNew-btn ${mobile && authCode && 'login_high'}`} onClick={mobile && authCode ? this.next : () => {return;}}>{this.props.btnTitle}</div>
          {this.state.isShowImageCode && <ImageAuth imgSuccess={this.sendAuthCode} closeImgAuth={() => this.setState({ isShowImageCode: false })} onRef={ node => this.ImageAuth = node }></ImageAuth>}
        </div>
        <div className='loginNew-bottom'>
        </div>
      {modal}
      {this.state.showProtocol && <PartnerApply closeFunc={this.closeFunc}></PartnerApply>}
    </div>
    )
  }
}

LoginNew.propTypes = {
  title: PropTypes.string.isRequired,
  btnTitle: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,
  nextFunc: PropTypes.func.isRequired
}

export default LoginNew;